<template>
  <div id="kv-banner" class="banner" :style="{ height: vm.isMobile && height }">
    <div ref="animationPic" class="content"></div>
  </div>
</template>

<script>
import lottie from 'lottie-web/build/player/lottie_svg.min';
// import animationData from './js/bannerJSON/data-tw.json';
// import animationDataZh from './js/bannerJSON/data-zh.json';
const requireContext = require.context('./js/bannerJSON', false, /\.json$/, 'lazy');
export default {
  inject: ['vm'],
  data() {
    return {
      height: document.documentElement.clientHeight + 'px'
    };
  },
  mounted() {
    // 默认采用data-lang 的json文件，如果没有则向后兼容改为 data.json 的文件，避免下面代码重复更改
    requireContext(`./data-${this.vm.lang}.json`)
      .catch(() => requireContext('./data.json'))
      .then(data => {
        // 预加载，可能导致线上重复加载同一个文件，但是由于第一个文件缓存，所以网速保证了
        if (location.href.indexOf('localhost:800') > -1) return;
        this.screenLottieAnimation = lottie.loadAnimation({
          container: this.$refs.animationPic,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          animationData: data
        });
      });

    if (location.href.indexOf('localhost:800') > -1) return;
  }
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  height: 100vh;
  .content {
    position: absolute;
    width: 220px;
    height: 330px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
@media only screen and (min-width: 1950px) {
  .banner {
    .content {
      width: 308px;
      height: 462px;
    }
  }
}
@media only screen and (max-width: 734px) {
  .banner {
    .content {
      width: 100%;
      height: 378px;
    }
  }
}
</style>
